import { Controller } from "@hotwired/stimulus"

// Valide le fichier choisi avant de soumettre le formulaire d'import CSV
// (élèves, classes). L'ouverture/fermeture de la modale est gérée par le
// contrôleur `modal`. La soumission est native (non-Turbo), comme le
// comportement jQuery d'origine.
export default class extends Controller {
  static targets = ["file", "formatError", "emptyError"]

  submit(event) {
    event.preventDefault()
    const filename = this.fileTarget.value

    if (filename === "") {
      this.emptyErrorTarget.classList.remove("d-none")
      this.formatErrorTarget.classList.add("d-none")
    } else if (/.csv|.xls|.xlsx/.test(filename)) {
      this.element.submit()
    } else {
      this.formatErrorTarget.classList.remove("d-none")
      this.emptyErrorTarget.classList.add("d-none")
    }
  }
}
